<template>
  <div class="hero-search">

    <div class="hero-search__mobile">

      <div class="mobile-category">
        <div class="mobile-category__item">
          <a class="mobile-category__link" href="#" @click="show=1" :class="{ 'active' : show === 1 }">GENRE</a>
          <a class="mobile-category__link" href="#" @click="show=2" :class="{ 'active' : show === 2 }">STUDIO</a>
          <a class="mobile-category__link" href="#" @click="show=3" :class="{ 'active' : show === 3 }">MOVIE</a>
        </div>

        <div class="mobile-category__input">
          <div class="hero-search__select hero-search__select--city" v-show="show === 1" v-if="filterCity">
            <v-select :options="cities" placeholder="Select Country" @onselect="selectCountry"/>
          </div>
          <div class="hero-search__select hero-search__select--uni" v-show="show === 2" v-if="filterUni">
            <v-select :options="studios1" placeholder="Select Studio"/>
          </div>

          <div class="hero-search__select hero-search__select--dorm" v-show="show === 3" v-if="filterDorm">
            <v-select :options="dormTypes" placeholder="Select Movie Type"/>
          </div>
        </div>

      </div>
      <v-button
        class="hero-search__submit green mobile"
        icon="icon-search"
        icon-position="left"
      />

    </div>
    <div class="hero-search__left searchDesktop">
       <div class="hero-search__select hero-search__select--city" v-if="filterCity">
        <v-select :options="cities" placeholder="Select Country" @onselect="selectCountry"/>
      </div>
<!--              <input ref="myinput" class="select__list-search__wrp select-box"  list="datalist" placeholder="Şehir Seçiniz" style="height: 40px;
            padding-bottom: 0px; font-size:17px color:red"/>
        <datalist id="datalist" ref="datalistCities">
        <option
        v-for="dorm in cities" :key="dorm.id" :value=dorm.name v-on:click="selectCity()" class="select__option-title">
        </option>
      </datalist> -->
      <div class="hero-search__select hero-search__select--uni" v-if="filterUni">
        <v-select ref="dene" :options="studios1"
          placeholder="Select Network"
           @onselect="selectUni"
           :disabled="!selectedCity"
        />

<!--              <input ref="myinput2" list="datalist2"  class="select-box" placeholder="Üniversite Seçiniz" style="height: 40px;
            padding-bottom: 0px; font-size:17px"/>
        <datalist id="datalist2" ref="datalistCities">
        <option
        v-for="uni in universities" :key="uni.id" :value=uni.name onclick="selectUni" class="select__option">
        </option>
      </datalist>   -->

<!--         <v-select
          :options="universities"
          placeholder="Üniversite Seçinizz"
          @onselect="selectUni"
          :disabled="!selectedCity"
        /> -->
      </div>
      <div class="hero-search__select hero-search__select--dorm" v-if="filterDorm">
        <v-select
          :options="dormTypes"
          placeholder="Select Movie Type"
          @onselect="selectType"
        />
      </div>
    </div>
    <v-link
      :to="searchUrl"
      class="hero-search__submit green"
      icon="icon-search"
      icon-position="left"
      title="SEARCH NETWORKS"
      @click.native="makeSelection"
    />
  </div>
</template>

<script>
import axios from 'axios'
import Utility from '../../common'
import { SET_STUDIO_DETAILS } from '@/store/mutations.type'
export default {
  name: 'NetworkSearch',
  props: {
    cities: Array,
    studios: Array,
    filterCity: {
      type: Boolean,
      default: true
    },
    filterUni: {
      type: Boolean,
      default: true
    },
    filterDorm: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    studios1:[],
      errors:[],
      dormType: null,
      show: 1,
      //cities: [],
      universities: [],
      selectedCity: null,
      selectedUni: null,
      searchUrl: {},
      uniSelected: false,
      dormTypes: [
        {
          name: 'Movie',
          value: 'erkek'
        },
        {
          name: 'TV Show',
          value: 'kiz'
        }
      ]
    }
  },
  methods: {
    selectCountry(opt) {
    this.selectedCity = opt    
        /*
      this.list.filter(item => {
          if(item.code) {
          return item.origin_country== opt.code
          } else return ''
        })
*/
if(opt.name == 'All Countries') {
  this.studios1 = this.studios
}
else {
  /*
this.list1 = this.list.filter(function (el) {
  return el.origin_country == opt.code
})
*/
this.studios1 = []
let self = this
this.studios.forEach((item) => {
  if(item.origin_country == opt.code)
  self.studios1.push(item)
})

}
// this.list1 = newArray
    },      
      ac () {
    },
    makeSelection () {
      if(this.selectedCity && !this.selectedUni) {
      // let selectedCity  = this.selectedCity // this.cities.find(function (citty) { return citty.name == selected } )     
      this.$router.push(this.selectedCity.slug + '-movies/')
      } else {
        console.log('3-else. selected' + this.$refs.myinput2.value)
        let selected = this.$refs.myinput2.value
        // eslint-disable-next-line eqeqeq
        let selectedCity = this.universities.find(function (citty) { return citty.name == selected })
        this.$router.push({ name: 'Network', params: { slug: Utility.string_to_slug(selectedUni.name), id: selectedUni.id, studio:selectedUni.name } })
      }
    },
    selectCity (opt) {
        this.selectedCity = opt
        /*
      // this.$refs.dene.placeholder = 'Üniversite Seçiniz' // didnt work
      // let selected = this.$refs.myinput.value
      // this.selectedCity  = this.cities.find(function (citty) { return citty.name == selected } )
      this.selectedCity = opt
      if (!this.uniSelected) {
        // this.searchUrl = { name: 'City', params: { slug: opt.slug } }
      }
      // if (this.selectedCity) {
      let self = this
      axios.get('/site/home/universities/' + opt.id)
        .then(response => {
          self.universities = response.data
          self.filterUni = true
        })
      // }
      */
    },
    selectUni (opt) {
        this.$store.commit(SET_STUDIO_DETAILS, opt)
      this.uniSelected = true
      this.selectedUni = opt
      this.searchUrl = { name: 'Network', params: { slug: Utility.string_to_slug(opt.name), id: opt.id, studio:opt.name, network: Utility.string_to_slug(opt.name) } }
      if (!this.filterDorm) {
        this.$router.push(this.searchUrl)
      }
    },
    selectType (opt) {
      if (this.selectedUni) {
        this.searchUrl = { name: 'StudioProduct', params: { slug: Utility.string_to_slug(opt.name), type: opt.value } }
        this.$router.push(this.searchUrl)
      } else {
          this.$router.push(this.selectedCity.slug + '-' + opt.value + '-movies/') 
       // this.searchUrl = { name: 'CityGender', params: { slug: this.selectedCity.slug, type: opt.value } }
      }
    },
    getCities () {
      let self = this
      //axios.get('/site/home/select-cities')
      axios.get('/3/genre/movie/list?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US')
        .then(response => {
          self.cities = response.data.genres
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    showTab () {
      // console.log(this.show)
    }
  },
  created () {
      this.studios1 = this.studios
    // this.getCities()
  }
/*   mounted () {
    var self = this
    this.$refs.myinput.addEventListener('input', function (evt) {
      self.selectCity()
});

    this.$refs.myinput2.addEventListener('input', function (evt) {
      self.uniSelected = true
});
  }   */
}
</script>

<style lang="scss">
  @import "../../assets/scss/components/hero-search";
  @import "../../assets/scss/components/selectbox";

  .select-box{
  border-bottom: 1px solid #e4e4e4;
}
  .select__placeholder{
    font-size: 12px;
  }
</style>
